import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '@pt/environment';

import { MentoringPreviewApi } from './mentoring-preview-api.interface';
import { GetMentoringDetailsRes } from '../models';

@Injectable()
export class MentoringPreviewService implements MentoringPreviewApi {
  readonly #httpClient = inject(HttpClient);

  getMentoringDetails(
    templateId: number,
  ): Observable<GetMentoringDetailsRes> {
    return this.#httpClient.get<GetMentoringDetailsRes>(
      `${environment.apiHost}mentoring/admin/plans/${templateId}/preview/`,
    );
  }
}
